import React from 'react'
import { inject, observer } from 'mobx-react'
import './DateRangePicker.scss'
import { Button, TimePicker } from 'antd'
import dayjs from 'dayjs'
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


@inject('controller')
@observer
export class CalendarHeader extends React.Component<{
  controller?: any
  disabled?: boolean
  onChange: any
}> {
  public componentDidMount() {
    this.props.onChange(this.props.controller.calendarsDate)
  }

  private renderHeader = () => {
    const { calendarsDate } = this.props.controller

    return (
      <>
        <div className='flex items-center' style={{ padding: '5px 2px' }}>
          <div>
            <Button
              icon={<FontAwesomeIcon icon={faCaretLeft}/>}
              className='ml-5'
              size='small'
              onClick={() => {
                this.props.controller.calendarsDate = dayjs(calendarsDate).subtract(1, 'month')
                this.props.onChange(this.props.controller.calendarsDate) // Apply the changes to antd calendar component
              }}
              disabled={this.props.disabled}
            />
          </div>
          <div className='flex-1 text-center'>
            <div className='font-bold' style={{ fontSize: 14 }}>
              {/* {dayjs().months(calendarsDate.month())} */}

              test here//qwerty
            </div>
            <div style={{ fontSize: 10 }}>{calendarsDate.year()}</div>
          </div>
          <div>
            <Button
              icon={<FontAwesomeIcon icon={faCaretRight}/>}
              className='mr-5'
              size='small'
              onClick={() => {
                this.props.controller.calendarsDate = dayjs(calendarsDate).add(1, 'month')
                this.props.onChange(this.props.controller.calendarsDate) // Apply the changes to antd calendar component
              }}
              disabled={this.props.disabled}
            />
          </div>
        </div>
        {this.props.controller.showDateTimePicker && (
          <div className='calendarTimeSelector'>
            <TimePicker
              disabled={this.props.controller.selectedDates.length !== 2}
              value={this.props.controller.selectedTimeFrom ? this.props.controller.selectedTimeFrom : null}
              size='small'
              onChange={(time) => this.props.controller.handleTimeSelect(time)}
              style={{ marginRight: 4 }}
              placeholder='Time From'
            />

            <TimePicker
              disabled={!this.props.controller.selectedTimeFrom}
              value={this.props.controller.selectedTimeTo ? this.props.controller.selectedTimeTo : null}
              size='small'
              onChange={(time) => this.props.controller.handleTimeSelect(time, false)}
              style={{ marginLeft: 4 }}
              placeholder='Time To'
            />
          </div>
        )}
      </>
    )
  }

  public render() {
    return this.renderHeader()
  }
}
